import React from 'react';
import { observable, toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { getAvatarImageSrc } from '@utils/avatarImageSrc';

interface PCAvatarListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    size?: any  // 头像尺寸
    userList: any   // 用户列表
    userCount?: any  // 显示的用户数量，默认3个
}

@inject('app', 'site', 'user')
@observer
class PCAvatarList extends React.Component<PCAvatarListProps> {
    // 处理图片加载错误
    handleImageError: React.ReactEventHandler<HTMLImageElement> = (event) => {
        const imgElement = event.currentTarget;
        const avatarSize = this.props.size || 32;
        imgElement.src = getAvatarImageSrc(`${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize);
        // 防止默认图也加载失败时陷入死循环
        imgElement.onerror = null;
    };
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { userList, size, userCount } = this.props;
        const avatarSize = size || 32;
        // 正确的 style 对象
        const sizeStyle = size ? {
            width: `${size}px`,
            height: `${size}px`,
            marginLeft: `-${size/2}px`
        } : {};
        // console.log(userList, '用户');
        // 转换为普通数组再 slice
        const observableArray = observable(userList);
        const normalArray = toJS(observableArray); // 转换为普通数组
        console.log(normalArray, '打赏用户列表');
        return <>
            <div className={styles.avatarListBox} style={{width: size ? (userCount + 1) * size/2 + 'px' : (userCount + 1) * 16 + 'px' }}>
                {normalArray.slice(0, userCount ? userCount : 3).map((item: any, index: any) => (
                    <img src={getAvatarImageSrc(item.avatar || item || `${BASE_IMG_URL}/common/avatar.png`, avatarSize, avatarSize)} onError={this.handleImageError} alt="" style={{ ...sizeStyle, zIndex: index }} className={styles.avatar}/>
                ))}
            </div>
        </>;
        
    }
}

export default PCAvatarList;
